import React from 'react';
import logoFB from '../../../assets/review/logoFB.svg';
import logoGMB from '../../../assets/review/logoGMB.svg';
import logoOS from '../../../assets/review/logoOS.svg';
import { TemplateId } from '../TemplateRegistry';

interface SourceLogoProps {
    network: string;
    template: TemplateId;
}

const SourceLogo: React.FC<SourceLogoProps> = ({ network, template }) => {
    let logoSrc = null;

    if (network === 'google_my_business') {
        logoSrc = logoGMB;
    } else if (network === 'facebook') {
        logoSrc = logoFB;
    } else if (network === 'opinion_system') {
        logoSrc = logoOS;
    }

    if (!logoSrc) {
        return null;
    }

    return (
        <div className="w-[136px] h-[136px] p-5 bg-white rounded-[10px] inline-flex justify-center items-center gap-2.5">
            <img
                src={logoSrc}
                alt={`Logo ${network}`}
                className="w-20 h-20 object-contain"
                crossOrigin="anonymous"
            />
        </div>
    );
};

export default SourceLogo;
